/**
 * Shared by posting returns and router recovery so validation matches URL parsing.
 * Posting uses the synthetic base for root-relative returns; the router supplies its real URL.
 * Query values and escaped path characters are already serialized and must not be decoded.
 */
export function internalNavigationTarget(value: string, baseHref = "https://navigation.invalid/"): string | null {
  // Browsers strip ASCII controls and treat path backslashes as authority separators.
  if (!value || /[\u0000-\u001f\u007f]/.test(value) || value.split(/[?#]/, 1)[0].includes("\\")) return null;
  try {
    const base = new URL(baseHref);
    const target = new URL(value, base);
    // Capacitor URLs have opaque origins, so origin equality alone cannot constrain their host.
    if (target.origin !== base.origin || target.protocol !== base.protocol || target.host !== base.host
      || target.username || target.password) return null;
    // Dot-segment normalization can create //, which would become an authority on reuse.
    if (!target.pathname.startsWith("/") || target.pathname.startsWith("//")) return null;
    return target.pathname + target.search + target.hash;
  } catch {
    return null;
  }
}
